import { htmlUnescape } from '@naturalcycles/js-lib'
import { languageContext } from '@src/context/language.context'
import { useExperimentImpression } from '@src/hooks/useExperimentImpression'
import { usePageNameClass } from '@src/hooks/usePageNameClass'
import { ConsumerPageTypes, PageType, usePageType } from '@src/hooks/usePageType'
import classNames from 'classnames'
import type { ReactNode } from 'react'
import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import styles from './Page.module.scss'

export interface PageProps {
  children: ReactNode
  title?: string
  extraBodyClass?: string
}

export function Page({ children, title = '', extraBodyClass = '' }: PageProps): ReactNode {
  const pageType = usePageType()
  const pageSlug = usePageNameClass()
  const { locale } = useContext(languageContext)
  useExperimentImpression()

  const bodyClasses = classNames(pageSlug, extraBodyClass, {
    'nc-consumer': [...ConsumerPageTypes].includes(pageType),
  })

  const mainClassNames = classNames({
    [styles.Page__main]: [PageType.Campaign].includes(pageType),
  })

  return (
    <>
      <Helmet>
        {/* eslint-disable-next-line react/no-unknown-property */}
        <html lang={locale} prefix="og: http://ogp.me/ns#" />
        <title>{htmlUnescape(title)}</title>
        <body className={bodyClasses} />
      </Helmet>

      <main className={mainClassNames}>{children}</main>
    </>
  )
}
